<div class="modal-content video-modal-content">
  <div class="modal-header" #handle>
    <h4 class="title is-size-4" translate="home.manual-modal.title"></h4>
  </div>
  <div class="modal-body">
    <video controls autoplay class="video-player">
      <source src="/assets/custom/manual.mp4" type="video/mp4" />
    </video>
  </div>
  <div class="modal-footer">
    <div class="is-flex is-justify-content-flex-end">
      <button type="button" (click)="close()" fino-button translate>
        home.manual-modal.close
      </button>
    </div>
  </div>
</div>
